var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_8232_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66669 10.6654C2.66669 9.25088 3.22859 7.89432 4.22878 6.89413C5.22898 5.89393 6.58553 5.33203 8.00002 5.33203H24C25.4145 5.33203 26.7711 5.89393 27.7713 6.89413C28.7714 7.89432 29.3334 9.25088 29.3334 10.6654V21.332C29.3334 22.7465 28.7714 24.1031 27.7713 25.1033C26.7711 26.1035 25.4145 26.6654 24 26.6654H8.00002C6.58553 26.6654 5.22898 26.1035 4.22878 25.1033C3.22859 24.1031 2.66669 22.7465 2.66669 21.332V10.6654Z",
    stroke: "#BEBEBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3333 12L20 16L13.3333 20V12Z",
    fill: "#BEBEBE",
    stroke: "#BEBEBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8232_1692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic-video.23f0a1f3196d75dc0dabe59e691afcbc.svg";
export { ForwardRef as ReactComponent };